export default {
  preheader: 'Meet your new match',
  header: 'Find your best credit cards',
  subtitle:
    'Quickly see which cards offer the lowest rate, most cash back or sweetest perks.',
  subtitleMobile:
    'Quickly see which cards offer the lowest rate, most cash back or sweetest perks.',
  buttonText: 'Find cards',
  backgroundImage:
    'https://www.nerdwallet.com/cdn/homepage/images/nw-hp-find-your-best-cc.svg',
  backgroundClassname: 'cc-tool-image',
};
